/**
 * 归一化应用基础路径，确保前后斜杠，并支持空值回退根路径。
 */
export const normalizeBasePath = (base?: string) => {
  if (!base) return '/'
  const withLeading = base.startsWith('/') ? base : `/${base}`
  return withLeading.endsWith('/') ? withLeading : `${withLeading}/`
}

/**
 * 返回带域名的应用基础地址，便于做重定向。
 */
export const getAbsoluteBaseUrl = () => {
  const base = normalizeBasePath(import.meta.env.VITE_PUBLIC_PATH)
  const origin = typeof window !== 'undefined' ? window.location.origin : ''
  return base === '/' ? `${origin}/` : `${origin}${base}`
}
